import WarnIcon from "./WarnIcon";

/**
 * DS Banner: one anatomy, four intents. See COMPONENTS.md.
 *
 * Warning does not use a glyph. The DS requires the filled hazard triangle
 * because a thin outline in olive on yellow is not reliably legible for this
 * app's users, which is what WarnIcon draws.
 */
const GLYPH = {
  info: "bi bi-info-circle",
  danger: "bi bi-x-lg",
  success: "bi bi-check-lg",
};

export default function Banner({ intent = "info", title, className = "", children, ...rest }) {
  return (
    <div
      className={`peb-banner peb-banner--${intent} ${className}`}
      role={intent === "danger" ? "alert" : "status"}
      {...rest}
    >
      {intent === "warning"
        ? <WarnIcon size={24} className="peb-banner__icon" />
        : <i className={`peb-banner__icon ${GLYPH[intent]}`} aria-hidden="true" />}
      <div className="peb-banner__body">
        {title && <strong className="peb-banner__title">{title}</strong>}
        {children}
      </div>
    </div>
  );
}
